module.exports = __webpack_public_path__ + "static/media/tipos_mamilo.f29dbd68.png";